import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, merge, throttleTime } from 'rxjs';
import { AppConfigService } from 'app/app-config.service';

@Injectable({ providedIn: 'root' })
export class SessionMonitorService {
    private readonly _throttleMs = 300000; // 5 นาที (300,000 ms)

    constructor(
        private _http: HttpClient,
        private _appConfigService: AppConfigService
    ) { }

    /**
     * เริ่มต้นการตรวจจับ Activity เพื่อทำ Sliding Expiration
     */
    startMonitoring(): void {
        // รวมเหตุการณ์การขยับเมาส์, กดปุ่ม หรือคลิก
        const userActivity$ = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'keydown'),
            fromEvent(document, 'click')
        );

        userActivity$.pipe(
            throttleTime(this._throttleMs)
        ).subscribe(() => {
            this.refreshSession();
        });
    }

    /**
     * ยิง API เพื่อต่ออายุ Session และ Refresh Antiforgery Token
     */
    public refreshSession(): void {
        const config = this._appConfigService.getConfiguration();
        if (!config || !config.apiUrl) return;

        const url = `${config.apiUrl}/antiforgery/token`;

        this._http.get(url, { withCredentials: true }).subscribe({
            next: () => console.log('[SessionMonitor] Session extended.'),
            error: (err) => console.error('[SessionMonitor] Failed to refresh session.', err)
        });
    }
}
